"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriggerButton = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TriggerButtonMixin = require("../../mixins/components/TriggerButtonMixin");
var _index = require("../Icon/index");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
/**
 * A standalone component for opening `Tooltip` and `Popover` components.
 *
 * The default child for `Popper` and `Trigger`.
 *
 * @related ['Popover', 'Tooltip', 'Trigger', 'TriggerText']
 * @since 7.0.0
 */
var TriggerButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "TriggerButton",
  componentId: "c11n-8-107-0__sc-p0gsxu-0"
})(["", ""], _TriggerButtonMixin.TriggerButtonMixin);
exports.TriggerButton = TriggerButton;
TriggerButton.displayName = 'TriggerButton';
TriggerButton.propTypes = {
  /**
   * The trigger's button content.
   */
  children: _propTypes.default.node,
  /**
   * The trigger's button type attribute.
   */
  type: _propTypes.default.string
};
TriggerButton.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_index.IconHelp, {
    size: "xs"
  }), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, "Help")),
  // Prevents submits when included in a form tag
  type: 'button'
};

/** @component */